var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [
      _vm._v(
        _vm._s(_vm.resultsForTerm) + ' "' + _vm._s(_vm.mutatedQuery) + '".'
      )
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "views-exposed-form search-field-form",
        on: { submit: _vm.search }
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hideSuggestList,
                expression: "hideSuggestList"
              }
            ],
            staticClass: "search-field-form__input-wrapper"
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mutatedQuery,
                  expression: "mutatedQuery"
                }
              ],
              ref: "input",
              staticClass:
                "search-field-form__input form-text form-item__input",
              attrs: { type: "text" },
              domProps: { value: _vm.mutatedQuery },
              on: {
                keyup: function($event) {
                  return _vm.addSearchSuggestions()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.mutatedQuery = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("ul", {
              ref: "suggestList",
              staticClass: "hide search__form-autocomplete"
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "search-field-form__clear",
                on: { click: _vm.clearInput }
              },
              [_c("i", { staticClass: "icon-cross-circle" })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-actions js-form-wrapper form-wrapper",
            attrs: {
              "data-drupal-selector": "edit-actions",
              id: "edit-actions"
            }
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "button button--md button--fill-orange button js-form-submit form-submit",
                on: { click: _vm.search }
              },
              [_vm._v(_vm._s(_vm.searchLabel))]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tabs-overflow-outer" }, [
      _c("div", { staticClass: "tabs-overflow-inner" }, [
        _vm.resultList.length > 0
          ? _c(
              "ul",
              { staticClass: "tabs-nav search-result-tabs" },
              [
                _c(
                  "li",
                  {
                    staticClass: "facet-item",
                    class: { active: "all" === _vm.currentFilter }
                  },
                  [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.setFilter("all")
                          }
                        }
                      },
                      [
                        _vm._v("All"),
                        _c("span", [
                          _vm._v(" (" + _vm._s(_vm.resultList.length) + ")")
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.types, function(type) {
                  return type.count
                    ? _c(
                        "li",
                        {
                          staticClass: "facet-item",
                          class: { active: type.id === _vm.currentFilter }
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.setFilter(type.id)
                                }
                              }
                            },
                            [
                              _vm._v(_vm._s(type.name)),
                              _c("span", [
                                _vm._v(" (" + _vm._s(type.count) + ")")
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                })
              ],
              2
            )
          : _c("p", [_vm._v(_vm._s(_vm.noResults))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "resultlist" }, [
      _c(
        "div",
        { staticClass: "results-wrapper" },
        [
          _vm._l(_vm.filteredItems, function(entry) {
            return [
              _c(
                "a",
                {
                  key: entry.id,
                  staticClass: "search-results-item show-opt-in-form action",
                  attrs: { href: entry.url }
                },
                [
                  _c(
                    "h2",
                    { staticClass: "search-results-item__title heading-4" },
                    [_vm._v(_vm._s(entry.title))]
                  )
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "search-results-item__text text--body" }, [
                entry.highlight
                  ? _c(
                      "span",
                      { domProps: { innerHTML: _vm._s(entry.highlight) } },
                      [_c("br")]
                    )
                  : _c(
                      "span",
                      { domProps: { innerHTML: _vm._s(entry.description) } },
                      [_c("br")]
                    ),
                _vm._v(" "),
                entry.abstract
                  ? _c("span", {
                      domProps: { innerHTML: _vm._s(entry.abstract) }
                    })
                  : _vm._e()
              ])
            ]
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }